import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="spin-container">
      <div className="spin"></div>
    </div>
  );
};

export default Loading;
